import PropTypes from 'prop-types';

import 'highcharts/modules/wordcloud';
import 'highcharts/modules/exporting';
import 'highcharts/modules/export-data';

import Chart from '../../charts/Chart';

import { useTheme, THEMES_DARK, WORD_CLOUD_COLORS } from '@utilities';

import styles from '../Chart/_index.module.scss';

const WordCloud = ({ data }) => {
  const theme = useTheme();
  const wordCloudColors =
    theme === THEMES_DARK.value ? WORD_CLOUD_COLORS.dark : WORD_CLOUD_COLORS.light;
  const wordCloudFreqMin = 7;

  const filteredData = data
    .filter((point) => point.weight >= wordCloudFreqMin)
    .map((point, index) => ({
      ...point,
      color: wordCloudColors[index % wordCloudColors.length],
    }));

  const chartOptions = {
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    series: [
      {
        data: filteredData,
        maxFontSize: 80,
        minFontSize: 14,
        name: 'Occurrences',
        rotation: {
          from: 0,
          to: 0,
        },
        type: 'wordcloud',
      },
    ],
    tooltip: {
      enabled: true,
    },
  };

  return (
    <Chart
      chartTitle={`Word Cloud - ${filteredData.length} Words`}
      className={styles['chart-word-cloud']}
      options={chartOptions}
    />
  );
};

WordCloud.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      weight: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default WordCloud;
